import React from 'react'

function Error404() {
  return (
    <div className="flex justify-center items-center w-full h-full bg-white">
    <h2 className="text-center text-red-500 text-[2rem] ">Error 999: Página no encontrada</h2>
  </div>
  )
}

export default Error404
